var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-layout",
        { attrs: { row: "", wrap: "" } },
        [
          _c(
            "v-flex",
            {
              class: { "ml-5": _vm.$vuetify.breakpoint.mdAndUp },
              attrs: { xs12: "", "pt-2": "" }
            },
            [
              _c(
                "v-btn",
                {
                  staticClass: "ml-0",
                  attrs: {
                    color: "primary",
                    outline: "",
                    block: _vm.$vuetify.breakpoint.smAndDown
                  },
                  on: {
                    click: function($event) {
                      return _vm.open()
                    }
                  }
                },
                [
                  _c("v-icon", { attrs: { left: "", color: "primary" } }, [
                    _vm._v("people")
                  ]),
                  _vm._v(" "),
                  _vm.$vuetify.breakpoint.xsOnly
                    ? _c("div", [
                        _vm._v(
                          _vm._s(_vm.agents.length) +
                            " / " +
                            _vm._s(_vm.$store.state._User.colleagues.length)
                        )
                      ])
                    : _c("div", [
                        _vm._v(
                          _vm._s(_vm.agents.length) +
                            " / " +
                            _vm._s(
                              _vm.$tc(
                                "agents",
                                _vm.$store.state._User.colleagues.length,
                                {
                                  count:
                                    _vm.$store.state._User.colleagues.length
                                }
                              )
                            )
                        )
                      ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { scrollable: "", persistent: "", "max-width": "350px" },
          model: {
            value: _vm.dialog,
            callback: function($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog"
          }
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticClass: "primary white--text subheading" },
                [
                  _vm._v(
                    _vm._s(_vm._f("cap")(_vm.$t("select"))) +
                      " " +
                      _vm._s(_vm.$tc("agents", 2, { count: " " }))
                  )
                ]
              ),
              _vm._v(" "),
              _c("v-divider"),
              _vm._v(" "),
              _c(
                "v-card-text",
                { staticStyle: { height: "400px" } },
                [
                  _c("v-data-table", {
                    staticClass: "elevation-1",
                    attrs: {
                      headers: _vm.header,
                      items: _vm.$store.state._User.colleagues,
                      "item-key": "USR_ID",
                      "select-all": "primary",
                      "hide-actions": "",
                      "total-items": _vm.$store.state._User.colleagues.length
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "headers",
                        fn: function(props) {
                          return [
                            _c("tr", [
                              _c(
                                "th",
                                [
                                  _c("v-checkbox", {
                                    attrs: {
                                      color: "primary",
                                      "hide-details": "",
                                      "input-value":
                                        props.all ||
                                        _vm.agentsTmp.length ==
                                          _vm.agents.length,
                                      indeterminate: props.indeterminate
                                    },
                                    nativeOn: {
                                      click: function($event) {
                                        return _vm.toggleAll.apply(
                                          null,
                                          arguments
                                        )
                                      }
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("th", { staticClass: "text-xs-left" }, [
                                _c("span", { staticClass: "subheading" }, [
                                  _vm._v(_vm._s(_vm.header[0].text))
                                ])
                              ])
                            ])
                          ]
                        }
                      },
                      {
                        key: "items",
                        fn: function(props) {
                          return [
                            _c(
                              "td",
                              [
                                _vm.withoutMe &&
                                props.item.USR_ID == _vm.$store.state._User.id
                                  ? _c("v-checkbox", {
                                      attrs: {
                                        color: "primary",
                                        "hide-details": "",
                                        value: "",
                                        "input-value": _vm.iAmChoosen
                                      }
                                    })
                                  : _c("v-checkbox", {
                                      attrs: {
                                        color: "primary",
                                        "hide-details": ""
                                      },
                                      model: {
                                        value: props.selected,
                                        callback: function($$v) {
                                          _vm.$set(props, "selected", $$v)
                                        },
                                        expression: "props.selected"
                                      }
                                    })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "td",
                              [
                                _c("wz-avatar", {
                                  attrs: {
                                    username:
                                      props.item.USR_FIRST_NAME +
                                      " " +
                                      props.item.USR_LAST_NAME,
                                    src:
                                      _vm.domaine +
                                      "/public/media/user/small/" +
                                      props.item.USR_ID +
                                      "_avatar.jpg",
                                    size: "35px"
                                  }
                                }),
                                _vm._v(" "),
                                _c("span", { staticClass: "ml-2" }, [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        props.item.USR_FIRST_NAME +
                                          " " +
                                          props.item.USR_LAST_NAME
                                      ) +
                                      "\n              "
                                  )
                                ]),
                                _vm._v(" "),
                                props.item.USR_ID == _vm.$store.state._User.id
                                  ? _c("span", [
                                      _vm._v(
                                        "\n                (" +
                                          _vm._s(_vm.$t("me")) +
                                          ")\n              "
                                      )
                                    ])
                                  : _vm._e()
                              ],
                              1
                            )
                          ]
                        }
                      }
                    ]),
                    model: {
                      value: _vm.agentsTmp,
                      callback: function($$v) {
                        _vm.agentsTmp = $$v
                      },
                      expression: "agentsTmp"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("v-divider"),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { flat: "" },
                      on: {
                        click: function($event) {
                          return _vm.cancel()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("cancel")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        disabled:
                          _vm.agentsTmp.length < _vm.min ||
                          _vm.agentsTmp.length > _vm.max,
                        color: "primary"
                      },
                      on: {
                        click: function($event) {
                          return _vm.submit()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("submit")))]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0858d0de", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0858d0de","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/watcheezy/WzSelectAgents.vue
// module id = null
// module chunks = 